<template>
  <div
    class="empty-state"
  >
    <div class="empty-state__illustration">
      <svg
        width="48"
        height="58"
        xmlns="http://www.w3.org/2000/svg"
      ><g
        transform="translate(1 1)"
        stroke="var(--gray)"
        stroke-width="2"
        fill="none"
        fill-rule="evenodd"
      ><path d="M2 0h42a2 2 0 0 1 2 2v52a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2Z" /><path
        stroke-linecap="round"
        d="M22 44h16M22 29h16M22 14h16"
      /><path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8 14.386 11.24 18 16 10"
      /><circle
        cx="12"
        cy="29"
        r="4"
      /><circle
        cx="12"
        cy="44"
        r="4"
      /></g></svg>
    </div>
    <h1 class="h4 empty-state__title">
      <slot name="title" />
    </h1>
    <p class="empty-state__description">
      <slot name="description" />
    </p>
  </div>
</template>

<style lang="scss" scoped>
.empty-state {
  border: none;
  padding: unset;
}

.empty-state__title {
  margin-top: 1.5rem;
}
</style>
